export const validateEmailAddress = (valor) => {
    //var RE = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3,4})+$/;
    const emailArray = valor.split(';');
    if (emailArray.length < 1) {
        return false;
    }
    let emailRegex = /^[a-zA-Z0-9_.+-]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/
    for (let email of emailArray) {
        if (!emailRegex.test(email.trim())) {
            return false;
        }
    }
    return true;
}